import { useDialogs } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { ButtonProps, Dialog } from '@optimus-web/core';
import { usePosMicrosConfigurationContext } from '../../contexts/posMicrosConfigurationContext';
import { DELETE_MICROS_OUTLET_DIALOG_NAME } from '../constant';

interface DeleteDialogProps {
    rowIndex: number;
}

export const DeleteMicrosOutletDialog = ({ rowIndex }: DeleteDialogProps) => {
    const { closeDialog } = useDialogs();
    const { setPosMicrosConfigurationState } = usePosMicrosConfigurationContext();

    const cancelDelete = () => closeDialog(DELETE_MICROS_OUTLET_DIALOG_NAME);
    const handleDeleteOutlet = () => {
        setPosMicrosConfigurationState((prevState) => {
            const microsOutlets = prevState.microsOutlets?.filter((_, index) => rowIndex !== index);

            return { ...prevState, microsOutlets };
        });
        closeDialog(DELETE_MICROS_OUTLET_DIALOG_NAME);
    };

    const deleteActions: ButtonProps[] = [
        {
            children: lt('Cancel'),
            onClick: cancelDelete,
            variant: 'tertiary',
            size: 'medium',
            type: 'submit',
        },
        {
            children: lt('Remove'),
            onClick: () => handleDeleteOutlet(),
            variant: 'destructive',
            size: 'medium',
            type: 'submit',
        },
    ];

    return (
        <Dialog title={lt('Delete')} actions={deleteActions} loading={false} onClose={cancelDelete} active>
            {lt('DeleteMicrosOutlet')}
        </Dialog>
    );
};
